export type AngleKey = 'thoughtful' | 'contrarian' | 'bold' | 'personal' | 'viral';
export type FormatKey = 'linkedin' | 'tweet' | 'thread' | 'script' | 'email' | 'carousel';

export const ANGLES: Record<AngleKey, { label: string; description: string }> = {
  thoughtful: { label: 'Thoughtful',  description: 'Reflective, nuanced take' },
  contrarian: { label: 'Contrarian',  description: 'Challenges the consensus' },
  bold:       { label: 'Bold',        description: 'Strong, provocative stance' },
  personal:   { label: 'Personal',    description: 'First-person experience' },
  viral:      { label: 'Viral',       description: 'Shareable, punchy format' },
};

export enum InsightActionTypes {
  API_RESPONSE_SUCCESS    = '@@insight/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR      = '@@insight/API_RESPONSE_ERROR',
  DISTILL                 = '@@insight/DISTILL',
  SELECT_ANGLE            = '@@insight/SELECT_ANGLE',
  HYDRATE_FROM_EXPLORE    = '@@insight/HYDRATE_FROM_EXPLORE',
  HYDRATE_FROM_LIBRARY    = '@@insight/HYDRATE_FROM_LIBRARY',
  CONFIRM_SAVE            = '@@insight/CONFIRM_SAVE',
  SET_EXPLORE_SESSION_ID  = '@@insight/SET_EXPLORE_SESSION_ID',
  RESET                   = '@@insight/RESET',
}

export interface PovData {
  agree: string;
  disagree: string;
}

export interface InsightState {
  rawThought: string;
  distilledInsight: string;
  topic: string;
  toneTags: string[];
  hook: string;
  pov: PovData | null;
  selectedAngle: AngleKey | null;
  insightId: string | null;
  exploreSessionId: string | null;
  isLoading: boolean;
  error: string | null;
}
